import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";

export const expandMore = ({ size = 15, color = "white" }) => {
  return <ExpandMoreRoundedIcon />;
};
